import { client } from '../client';
import { urls } from '../endpoints';
import {
  ApiResponse,
  FacilityCreateType,
  FacilityDetailType,
  FacilityLiteDto,
  FacilitySearchParams,
  FacilityType,
  FacilityUpdateType,
  GridResponse,
  UpdateFacilityStatusType,
} from '../../types/types';

export const getFacilitiesListLite = async () => {
  try {
    const response = await client.get<ApiResponse<FacilityLiteDto[]>>(
      urls.facilitiesListLite,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createFacilityRequest = async (
  facilityData: FacilityCreateType,
) => {
  try {
    const response = await client.post<ApiResponse<number>>(
      urls.createFacilityByAdmin,
      facilityData,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateFacilityRequest = async (
  facilityData: FacilityUpdateType,
) => {
  try {
    const response = await client.put<ApiResponse<number>>(
      urls.updateFacility(facilityData.facilityId),
      facilityData,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteFacilityRequest = async (facilityId: number) => {
  try {
    const response = await client.delete<ApiResponse<number>>(
      urls.deleteFacility(facilityId),
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const searchFacilitiesRequest = async (
  params?: FacilitySearchParams,
) => {
  try {
    const response = await client.get<
      ApiResponse<GridResponse<FacilityType[]>>
    >(urls.searchFacilities(params));
    if (response.status === 200) {
      return response.data;
    }
    return null;
  } catch (error) {
    console.error('Error searching facilities:', error);
    return null;
  }
};

export const getFacilityByIdRequest = async (
  facilityId: number,
  withSports?: boolean,
) => {
  try {
    const response = await client.get<ApiResponse<FacilityDetailType>>(
      urls.getFacilityById(facilityId, withSports),
    );
    if (response.status === 200) {
      return response.data;
    }
    return null;
  } catch (error) {
    console.error('Error searching facilities:', error);
    return null;
  }
};

export const updateFacilityStatusRequest = async (
  data: UpdateFacilityStatusType,
) => {
  try {
    const response = await client.patch<ApiResponse<number>>(
      urls.UpdateFacilityStatus,
      data,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
